import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fi-icon-custom-user",
  "use": "fi-icon-custom-user-usage",
  "viewBox": "0 0 29.92 29.92",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 29.92 29.92\" id=\"fi-icon-custom-user\"><circle cx=\"14.96\" cy=\"14.96\" r=\"14.96\" fill=\"#96d0fc\" /><path d=\"M15.03 14.59a4.24 4.24 0 10-4.23-4.24 4.24 4.24 0 004.23 4.24zm3 1.06h-.56a5.74 5.74 0 01-4.82 0h-.62a4.44 4.44 0 00-4.45 4.44v2.13a1.59 1.59 0 001.59 1.58h11.64a1.59 1.59 0 001.59-1.58v-2.13a4.44 4.44 0 00-4.44-4.44z\" fill=\"#fff\" opacity=\".9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol